import { UnitCardTypes } from '../../../../components/unitDetailsCard/UnitCardTypes';

export namespace ConfirmationTypes {
  export type TConfirmationComponent = {
    height?: number;
    confirmationSectionConfig: TConfirmation;
    tenantToken?: string;
    facPublicKey?: string;
  };
  export type TConfirmationSection = {
    title: string;
    fields: TFields[];
  };
  export type TConfirmation = {
    heading: string;
    theme: 'dark' | 'light';
    sections: TConfirmationSection[];
    unitsData: any;
    unitCardsConfig: UnitCardTypes.TUnitCardsConfig;
    individualUnitsData: any;
    facilityId: string;
    ledgerId: string;
  };

  export type TFields = {
    key: string;
    label: string;
    value: string;
  };
  export type TIndividalFields = {
    individualItem: TFields;
  };
  export type TConfirmationAccordian = {
    contentArr: TConfirmationSection[];
    theme: 'dark' | 'light';
  };
  export type TConfirmationRequest = {
    [x: string]: any;
    name: {
      last_name: string;
      first_name: string;
    };
    address: {
      line1: string;
      line2: string;
      city: string;
      state: string;
      zip_code: number;
    };
    phone: {
      text_enabled_cell_number: string;
      primary_number: string;
      phone_number_list: {
        type: string;
        number: string;
      }[];
    };
    email: {
      email_address: string;
      is_email_enabled: boolean;
    };
    dob: string;
    id_proof: {
      driver_license: string;
      license_expiration: string;
    };
    military_info: {
      military_id: string;
      type: string;
      branch: string;
      deployed_until: string;
      division: string;
      commanding_officer: string;
      commanding_officer_phone: string;
    };
    other_address: {
      alternate_contact: {
        name: {
          first_name: string;
          last_name: string;
        };
        address: {
          line1: string;
          line2: string;
          city: string;
          state: string;
          zip_code: number;
        };
        phone: {
          cell_phone: string;
        };
        email: string;
      };
    };
    ledger: {
      label: string;
    }[];
  };
}
